import { Controller } from "stimulus";
import Pusher from "pusher-js";

export default class extends Controller {
  static values = {
    companyId: Number,
    pusherKey: String
  }

  connect() {
    this.handleLanguagesToggleClick = this.handleLanguagesToggleClick.bind(this);
    document.addEventListener('click', this.handleLanguagesToggleClick);

    if (!this.pusherKeyValue || !this.companyIdValue) {
      return;
    }

    this.pusher = new Pusher(this.pusherKeyValue, {
      cluster: 'us2'
    });

    this.channel = this.pusher.subscribe(`company-${this.companyIdValue}`);

    this.channel.bind('translation-completed', (data) => {
      this.handleTranslationCompleted(data);
    });

    this.channel.bind('translation-progress', (data) => {
      this.handleTranslationProgress(data);
    });

    this.channel.bind('translation-failed', (data) => {
      this.handleTranslationFailed(data);
    });

    this.channel.bind('translation-canceled', (data) => {
      this.handleTranslationFailed(data);
    });
  }

  disconnect() {
    if (this.handleLanguagesToggleClick) {
      document.removeEventListener('click', this.handleLanguagesToggleClick);
    }

    if (this.channel) {
      this.channel.unbind_all();
      this.pusher.unsubscribe(`company-${this.companyIdValue}`);
    }
    if (this.pusher) {
      this.pusher.disconnect();
    }
  }

  handleTranslationCompleted(data) {
    const badge = document.querySelector(
      `[data-testid="training-in-progress-badge"][data-training-id="${data.training_id}"]`
    );

    if (badge) {
      const spanBadge = badge.querySelector('.badge');
      if (spanBadge) {
        spanBadge.style.transition = 'background-color 0.2s ease, color 0.2s ease';
        spanBadge.style.backgroundColor = '#E8F5E9';
        spanBadge.style.color = '#3E8F00';
        spanBadge.style.height = '22px';
        spanBadge.style.borderRadius = '16px';
        spanBadge.style.padding = '2px 8px 2px 6px';
        spanBadge.style.gap = '4px';
        spanBadge.style.fontSize = '12px';
        spanBadge.style.fontWeight = '500';
        spanBadge.style.lineHeight = '18px';
        spanBadge.style.justifyContent = 'center';
        spanBadge.style.gap = '4px';
        
        spanBadge.innerHTML = `
          <span class="rounded-circle" style="width: 6px; height: 6px; background-color: #3E8F00; display: inline-block;"></span>
          Translation completed
        `;
      }
      
      badge.setAttribute('data-testid', 'training-translation-completed-badge');
    }

    if (data.languages && data.languages.length > 0) {
      this.updateCardLanguages(data.training_id, data.languages);
    }
  }

  handleTranslationProgress(data) {
    // No-op: we intentionally do not show percent in-progress.
  }

  handleTranslationFailed(data) {
    const selectors = [
      `[data-testid="training-in-progress-badge"][data-training-id="${data.training_id}"]`,
      `[data-testid="training-translation-completed-badge"][data-training-id="${data.training_id}"]`
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => node.remove());
    });
  }

  updateCardLanguages(trainingId, languages) {
    const container = document.querySelector(`[data-training-languages="${trainingId}"]`);
    if (!container) return;

    const textEl = container.querySelector('[data-languages-text]');
    if (!textEl) return;

    const normalizedLanguages = languages.filter(Boolean);
    if (normalizedLanguages.length === 0) return;

    const primary = normalizedLanguages.slice(0, 3);
    const extra = normalizedLanguages.slice(3);

    textEl.textContent = primary.join(', ');
    container.classList.remove('is-expanded');

    const card = container.closest('.index-training-card') || container.closest('.card');
    const duration = card?.querySelector('.training-duration, .training-duration-course-templates');
    if (duration) duration.classList.remove('d-none');

    let extraEl = container.querySelector('[data-languages-extra]');
    let toggleEl = container.querySelector('[data-languages-toggle]');
    if (!toggleEl) {
      toggleEl = container.querySelector('.training-languages__text a.el-link.purple.text-nowrap');
    }

    const generatedToggle = toggleEl?.hasAttribute('data-languages-toggle');

    if (extra.length > 0) {
      if (!extraEl) {
        extraEl = document.createElement('span');
        extraEl.className = 'd-none';
        extraEl.setAttribute('data-languages-extra', '');
        textEl.parentNode.insertBefore(extraEl, toggleEl);
      }
      extraEl.textContent = `, ${extra.join(', ')}`;
      extraEl.classList.add('d-none');

      if (!toggleEl) {
        toggleEl = document.createElement('a');
        toggleEl.className = 'ms-1 el-link purple text-nowrap';
        toggleEl.href = '#';
        toggleEl.setAttribute('data-languages-toggle', '');
        toggleEl.setAttribute('data-training-id', trainingId);
        toggleEl.textContent = '(See all)';
        textEl.parentNode.appendChild(toggleEl);
      } else {
        toggleEl.textContent = '(See all)';
      }
    } else {
      if (extraEl) extraEl.remove();
      if (generatedToggle && toggleEl) toggleEl.remove();
    }
  }

  handleLanguagesToggleClick(event) {
    const toggle = event.target.closest('[data-languages-toggle]');
    if (!toggle) return;

    event.preventDefault();

    const container = toggle.closest('[data-training-languages]');
    if (!container) return;

    const extra = container.querySelector('[data-languages-extra]');
    if (!extra) return;

    const isHidden = extra.classList.contains('d-none');
    extra.classList.toggle('d-none');
    container.classList.toggle('is-expanded', isHidden);
    toggle.textContent = isHidden ? '(See less)' : '(See all)';

    const card = container.closest('.index-training-card') || container.closest('.card');
    const duration = card?.querySelector('.training-duration, .training-duration-course-templates');
    if (!duration) return;

    if (!isHidden) {
      duration.classList.remove('d-none');
      return;
    }

    const containerRect = container.getBoundingClientRect();
    const durationRect = duration.getBoundingClientRect();
    const overlap = containerRect.bottom >= durationRect.top - 4;
    duration.classList.toggle('d-none', overlap);
  }
}
